module.exports = __webpack_public_path__ + "52b1c4df71e6e4d6da75e17a749c9649.pdf";